import { render, staticRenderFns } from "./UnviewedComplaintsForUser.vue?vue&type=template&id=00a57ba8&scoped=true&"
import script from "./UnviewedComplaintsForUser.vue?vue&type=script&lang=js&"
export * from "./UnviewedComplaintsForUser.vue?vue&type=script&lang=js&"
import style0 from "./UnviewedComplaintsForUser.vue?vue&type=style&index=0&id=00a57ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a57ba8",
  null
  
)

export default component.exports